import { memo, useCallback, useMemo } from 'react';
import { IconButton, Paper } from '@mui/material';

import { useHistoryStore } from '@/modules/history/useHistoryStore';
import { HistoryServiceFactory } from '@/modules/canvas/services/history/HistoryServiceFactory';
import { Undo, Redo } from '@/assets/icons';
import { useAppStore } from '@/modules/app/store/useAppStore';

import { styles } from '../styles';

function UndoRedoComponent() {
  const historySvc = useMemo(() => HistoryServiceFactory.getInstance().createHistoryService(), []);
  const { getHasUndo, getHasRedo } = useHistoryStore();
  const mode = useAppStore((state) => state.mode);
  const isDisabled = mode !== 'EDITABLE';

  const handleUndo = useCallback(() => {
    if (isDisabled) return;
    historySvc.undo();
  }, [historySvc, isDisabled]);

  const handleRedo = useCallback(() => {
    if (isDisabled) return;
    historySvc.redo();
  }, [historySvc, isDisabled]);

  return (
    <Paper style={styles.undoRedo}>
      <IconButton
        style={styles.iconButton}
        onClick={handleUndo}
        disabled={isDisabled || !getHasUndo()}
      >
        <Undo />
      </IconButton>
      <IconButton
        style={styles.iconButton}
        onClick={handleRedo}
        disabled={isDisabled || !getHasRedo()}
      >
        <Redo />
      </IconButton>
    </Paper>
  );
}

export const UndoRedo = memo(UndoRedoComponent);
